import { Event } from "../../../../Global/Base/Events";
import { TimerUtils } from "../../../../Global/Base/Utils/TimerUtils";
import { MenuType } from "../../../UI.Controls/Actions/MenuType";
import { Control, GenericControl } from "../Controls/Control";
import { ControlParams } from "../Controls/ControlInterfaces";
import { DesktopToolbarButton } from "../XGControls/Actions/ToolbarButton";
import { ToolbarGroup } from "./ToolbarGroup";
import { ToolbarGroups } from "./ToolbarGroups";

export type ActionsContainerParams = ControlParams & {
    ctrlID: string;
};

export class ActionsContainer extends Control {
    public ctrlID: string;
    public visibilityChange: Event<ActionsContainer, boolean> = new Event<ActionsContainer, boolean>();

    private _groups: ToolbarGroups;
    private _oldGroupsVisibility = false;

    public set groups(val: ToolbarGroups) {
        this._groups = val;
        this.visibilityChange.trigger(this, this._visible && this.groups.visible);
        this._groups.visibilityChange.add((_sender, e) => {
            if (e != this._oldGroupsVisibility) {
                this._oldGroupsVisibility = e;

                TimerUtils.waitOrCancel(`standardToolbarVisibilityChange${this.ctrlID}`, //`
                    () => {
                        this.visibilityChange.trigger(this, this._visible && this.groups.visible);
                    }, 300);
            }
        });
    }

    public get groups(): ToolbarGroups {
        return this._groups;
    }

    public get hasVisibleItems(): boolean {
        return this._visible && this.groups.visible;
    }

    constructor(params: ActionsContainerParams) {
        super(params);
        const { ctrlID } = params;
        this.groups = new ToolbarGroups(params);
        this.ctrlID = ctrlID;
        this.element.setAttribute("data-ctrlid", ctrlID);
    }

    public addAction(button: DesktopToolbarButton): void {
        this.element.appendChild(button.element);
    }

    public addOrFindGroup(locKey: string, toMenu: MenuType, ctrlID: string, priority?: number): ToolbarGroup {
        return this.groups.addOrFindGroup(locKey, toMenu, ctrlID, priority);
    }

    /**najde spravny masternode*/
    public findMasterNode(ctrlID: string): GenericControl[] {
        if (ctrlID == this.ctrlID) {
            const controls: GenericControl[] = [];
            controls.push(this);
            return controls;
        }
        return this.groups.findMasterNode(ctrlID);
    }

    public override dispose(): void {
        this._groups?.dispose();
        this.visibilityChange.removeAll();
        super.dispose();
    }
}
